export const STORAGEKEY = {
  token: 'token',
  authData: 'authData',
  userData: 'userData',
  layoutData: 'layoutData',
};
